import React, { Component } from 'react';

class DivInformacion extends Component {
  render() {
    return (      
        <div>
            {this.props.titulo &&
                <div className='paso-inicio__div-titulo-promo'>
                    <h2 className={`flex-grow md:pl-0`}>
                        {this.props.titulo}
                    </h2>
                </div>
            }
            <div className='paso-inicio__div-bajada-promo'>
                <span className={`flex-grow text-center md:text-right md:pl-0`}>
                    {this.props.descripcion}
                </span>
            </div>
        </div>
    ); 
  }
}

export default DivInformacion;